import { Container } from "react-bootstrap"
import { Outlet } from "react-router-dom"
import { Toaster, toast } from "react-hot-toast"

// Add a warning method to toast
toast.warning = (message, options = {}) => {
  return toast(message, {
    icon: '⚠️',
    duration: 10000,
    style: {
      borderLeft: '4px solid #ff9800',
      background: '#fff8e1',
    },
    ...options,
  })
}

toast.info = (message, options = {}) => {
  return toast(message, {
    icon: 'ℹ️',
    duration: 8000,
    style: {
      borderLeft: '4px solid #2196f3'
    },
    ...options,
  })
}

const PrivateLayout = () => {

  return (
    <div className="d-flex flex-column min-vh-100">
      <Container fluid className="p-0 m-0 flex-grow-1 w-100 d-flex">
        <Outlet />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            className: 'fw-semibold d-flex gap-1',
            style: {
              zIndex: '9999999',
              padding: '12px 25px',
            },
            success: {
              style: {
                borderLeft: '4px solid #4caf50'
              },
            },
            error: {
              style: {
                borderLeft: '4px solid #f44336'
              }
            },
            warning: (t) => ({
              ...t,
              style: {
                ...t.style,
                borderLeft: '4px solid #ff9800',
                background: '#fff8e1',
              }
            }),
          }}
        />
      </Container>
    </div>
  )
}
export default PrivateLayout